export const MISC_BULLSHIT = "Misc bullshit";

export const colors = [
  "White",
  "Blue",
  "Black",
  "Red",
  "Green",
  "Purple",
  "Colorless",
  MISC_BULLSHIT,
];

export const CHUNK_SIZE = 50;

export const MANA_REGEX = /({[WUBRGTCPHS0123456Y7X/Pickle]+})/; // /({[WUBRGTCP01234567X(2/W)]})/;

export const MISC_BULLSHIT_COLORS = ["Piss", "Pickle", "Brown"];
